import * as React from 'react';
import styles from './index.less';

interface ButtonProps {
  disabled?: boolean;
  style?: React.CSSProperties;
  children?: React.ReactNode;

  onClick?(): void;
}

function Button({ disabled = false, style = {}, children, onClick }: ButtonProps) {
  return (<div
    className={[styles.button, disabled ? styles.disabled : ''].join(' ')}
    style={{
      ...style,
      // ...(disabled ? {
      //   opacity: .4,
      //   cursor: 'not-allowed',
      // } : {
      //   cursor: 'pointer',
      // }),
    }}
    onClick={onClick}
  >{children}</div>);
}

export default Button;
